import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Page_settings } from '../../config/page_settings';
import strings from '../../lang/strings';
import { observer } from 'mobx-react';

const AlarmDetail = observer((props) => {
  const context = useContext(Page_settings);
  const [alarm, setAlarm] = useState(null);

  useEffect(() => {
    const { alarmId } = props.match.params;
    getAlarmDetail(alarmId);
  }, [props.match.params]);

  const getAlarmDetail = (alarmId) => {
    context.post(
      'member/alarm_detail',
      { alarm_id: alarmId },
      (response) => {
        setAlarm(response);
      },
      false,
      (err) => {
        context.showAlert(err.msg);
      }
    );
  };

  if (!alarm) {
    return <p>{strings.loading}</p>;
  }

  return (
    <div className="mt-30">
      <h1>{alarm.title}</h1>
      <p>{new Date(alarm.created_at).toLocaleString()}</p>
      <div className="alarm-content">
        <p>{alarm.content}</p>
      </div>
      <button onClick={() => props.history.push('/member/alarm_list')}>{strings.back}</button>
    </div>
  );
});

export default withRouter(AlarmDetail);
